
import callAPI from "./APIRequests";

export const getFinancialAmend = async (data) => {
    const res = await callAPI.post('/sopra/api/v1/sopra/requestFinancialAmmend', data);
    if (res.status == 200) {
        return { status: "success", value: res?.data?.fundedAmount ?? 0 }
    } else {
        return { message: res.message }
    }

}

export const userNameCheckApi = async (data) => {
    if(!data) return;

    const res = await callAPI.post('/auth/api/v1/auth/checkUserName', {"username": data});
    if (res.status == 200) {
        if(res?.data?.warningReason)
            return { warningReason: res.data.warningReason,alternateUsername:res.data?.alternateUsername}
    } else {
        return { message: res.message }
    }

}

export const validateMobileNumber = async (phoneNumber = '') => {
    let validationMessage;
    const response = await callAPI.post('/auth/api/v1/message/validatePhoneNumber', { phoneNumber })
    if (response.status === 200) {
       if (response?.data?.message === 'success'){
        validationMessage = 'success'
       }else{
           validationMessage = `${response?.data?.message}.`
       }
    }
    else {
        validationMessage = ''
    }

    return validationMessage;
}
